module.exports = __webpack_public_path__ + "06_long_black.ee888c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_long_black.png
// module id = k6Zu
// module chunks = 0